import React from "react";
import { BoxStyled } from "./../styledComponents/component";
import { Link } from "react-router-dom";
import { Button, CircularProgress, makeStyles } from "@material-ui/core";
import { Formik } from "formik";


let useStyle = makeStyles(() => ({
    root: {
        width: '100%',
        heigth: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        // w-full h-full flex justify-center items-center flex-col
    },
    title: {
        width: 'auto',
        // height: 16,
        display: 'flex',
        justifyContent: 'center',
        aligItems: 'center',
        margin: "10px 0px",
        // w-auto h-16 flex justify-center items-center mt-10
    },
    grid: {
        padding: '0px 5px',
        textAlign: 'center',
        backgroundColor: 'rgb(243,244,246)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        borderRadius: 8,
        // py-5 w-[25%] text-center bg-gray-100 flex justify-center items-center flex-col rounded-lg
    },
    gridText: {
        display: 'flex',
        justifyContent: 'between',
        alignItems: 'center',
        width: '82%',
        margin: 'auto'
        // flex justify-between items-center w-[82%] m-[auto]
    },
    rotate20: {
        position: 'absolute',
        left: '46%',
        top: '82%',
    },
    rotate40: {
        position: 'absolute',
        left: '43%',
        top: '77%',
    },
    rotate60: {
        position: 'absolute',
        left: '39%',
        top: '77%',
    },
    rotate80: {
        position: 'absolute',
        left: '35%',
        top: '77%',
    },
    rotate100: {
        position: 'absolute',
        left: '33%',
        top: '87%',
    },
    btnPrev: {
        border: '1px solid black',
        padding: '0.5rem 6rem',
        cursor: 'pointer',
        maxWidth: '100%',
        borderRadius: 8,
        "@media(max-width:768px)": {
            padding: '0.5rem 3.5rem',
        },
        "@media(max-width:640px)": {
            padding: '0.5rem 2.5rem',
        },
    },
    btnNext: {
        border: '0px solid black',
        padding: '0.5rem 6rem',
        cursor: 'pointer',
        maxWidth: '100%',
        borderRadius: 8,
        "@media(max-width:768px)": {
            padding: '0.5rem 3.5rem',
        },
        "@media(max-width:640px)": {
            padding: '0.5rem 2.5rem',
        },
    },
    gridBtns: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'ceter',
        marginTop: 15,
    }
}))

const EndQuestion = ({
    score,
    handleNextStep,
    handlePrevStep,
    loadingOms,
    apiSubmitOms,
}) => {

    let classes = useStyle();



    const handelRotate = (value) => {
        let number = value;
        switch (true) {
            case (0 <= number && number < 20):
                return 0
            case (20 <= number && number < 40):
                return 36
            case (40 <= number && number < 60):
                return 72
            case (60 <= number && number < 80):
                return 110
            case (80 <= number && number <= 100):
                return 150
            default:
                return 0
        }
    }

    const handelClassName = (value) => {
        let number = value;
        switch (true) {
            case (0 <= number && number < 20):
                return classes['rotate20']
            case (20 <= number && number < 40):
                return classes['rotate40']
            case (40 <= number && number < 60):
                return classes['rotate60']
            case (60 <= number && number < 80):
                return classes['rotate80']
            case (80 <= number && number <= 100):
                return classes['rotate100']
        }
    }

    return (
        <>
                        <BoxStyled minHeight={200}>
                            <div className={classes['root']} >
                                <div className={classes['title']}>
                                    <h3>
                                        نتیجه آزمون شما
                                    </h3>
                                </div>
                                <div className={classes['grid']} style={{ minWidth: 280 }}>
                                    {/* <div>
                            <h3>{score}</h3>
                        </div> */}
                                    <div style={{ position: 'relative', marginTop: 15, minHeight: 125 }}>
                                        <img src={'/media/image/chart.png'} alt="" style={{ transform: "scaleX(-1)" }} />
                                        <div
                                            style={{ transform: `rotate(${handelRotate(score)}deg)` }}
                                            className={`${handelClassName(score)}`}>
                                            <img src={'/media/image/aghrabeh.png'} alt="" />
                                        </div>
                                        <div className={classes['gridText']}>

                                        </div>
                                    </div>
                                    <div className="w-[90%] mt-2 m-[auto]">
                                        <hr />
                                        <p className="mt-3">
                                            {`شما در آزمون آنلاین با نمره ${score} درصد قبول شده اید برای ادامه درخواست خود  بر روی دکمه زیر  کلیک نمایید`}
                                        </p>
                                    </div>
                                </div>

                                <div className={classes['gridBtns']}>
                                    <div
                                        onClick={() => handlePrevStep()}
                                        className={` ${classes['btnPrev']}`} >
                                        بازگشت
                                    </div>
                                    {
                                        loadingOms
                                            ? <CircularProgress />
                                            : (
                                                <div
                                                    onClick={() =>  apiSubmitOms()}
                                                    className={` ${classes['btnNext']} bg-primaryColor text-white cursor-pointer`}  >
                                                    ثبت
                                                </div>
                                            )
                                    }
                                </div>

                            </div>
                        </BoxStyled>
        </>
    );
};

export default EndQuestion;
